// Generated by LiveScript 1.6.0
var ref$, id, log, filter, findInside, slug, initial, append, delay, isItem, isMenu, toIxChain, pushState, pub, sub, int, SIMULATED_LATENCY, narrow_mode, preload, MenuModel, MenuView, ServdMenu, slice$ = [].slice;
ref$ = require('utils'), id = ref$.id, log = ref$.log, filter = ref$.filter, findInside = ref$.findInside, slug = ref$.slug, initial = ref$.initial, append = ref$.append, delay = ref$.delay;
ref$ = require('./functions'), isItem = ref$.isItem, isMenu = ref$.isMenu, toIxChain = ref$.toIxChain;
pushState = require('history').pushState;
ref$ = require('pubsub'), pub = ref$.pub, sub = ref$.sub;
int = partialize$.apply(this, [parseInt, [void 8, 10], [0]]);
SIMULATED_LATENCY = 1;
narrow_mode = function(){
  return window.innerWidth < 768;
};
preload = function(src, λ){
  var i;
  i = new Image;
  i.onload = function(){
    return λ(true);
  };
  i.onerror = function(){
    return λ(false);
  };
  return i.src = src;
};
MenuModel = require('./model').MenuModel;
MenuView = require('./view').MenuView;
module.exports = ServdMenu = (function(){
  ServdMenu.displayName = 'ServdMenu';
  var menuUrl, prototype = ServdMenu.prototype, constructor = ServdMenu;
  menuUrl = '/ajax/menu.php';
  function ServdMenu($host, config){
    var menuView, menuData, getJsonData, onReceiveJsonData, getInitialDeeplinkState, this$ = this;
    this.config = config;
    this.menuDisplay = bind$(this, 'menuDisplay', prototype);
    this.dom = {
      main: $host
    };
    this.callbacks = {
      ready: id,
      height: id,
      fetched: id
    };
    this.view = menuView = new MenuView(this.dom.main, this.config.menu);
    this.data = menuData = new MenuModel;
    getJsonData = function(url, menuId){
      menuView.showBusyState();
      return delay(SIMULATED_LATENCY, function(){
        return $.ajax({
          url: url,
          type: 'get',
          dataType: 'json',
          data: {
            json: true,
            menuId: menuId
          },
          error: function(err){
            return console.error('Couldnt load menu', err.responseText);
          },
          success: function(res){
            menuView.hideBusyState();
            return onReceiveJsonData(res, menuId);
          }
        });
      });
    };
    onReceiveJsonData = function(data, menuId){
      data.name = 'root';
      menuData.init(data);
      menuView.render(data);
      getInitialDeeplinkState();
      this$.callbacks.ready(menuId);
      return this$.callbacks.fetched(data);
    };
    getInitialDeeplinkState = function(){
      var urlParts;
      urlParts = filter(id)(
      location.pathname.split('/'));
      if (urlParts[0] === 'menu' && urlParts.length > 1) {
        return pub('menu-display', toIxChain(urlParts[1]));
      } else {
        if (!narrow_mode()) {
          return pub('menu-display', [0]);
        } else {
          return pub('menu-display', []);
        }
      }
    };
    menuView.onHeightChange(function(height){
      return this$.callbacks.height(height, this$.config.menu);
    });
    sub('menu-restore', function(ixChain){
      var targetNode;
      ixChain = function(it){
        return it.map(int);
      }(
      toIxChain(ixChain));
      if (this$.config.menu !== ixChain[0]) {
        return;
      }
      targetNode = menuData.getByIndexChain(ixChain);
      if (menuView.standalone) {
        return this$.menuDisplay(ixChain);
      } else {
        return pushState(['menu', ixChain.join('-'), slug(targetNode.name)]);
      }
    });
    sub('menu-popup-dismiss', function(){
      return menuView.dismissPopup();
    });
    sub('menu-reset', function(menuId){
      if (menuId === this$.config.menu) {
        return pub('menu-restore', [menuId, 0]);
      }
    });
    getJsonData(menuUrl, this.config.menu);
  }
  ServdMenu.prototype.menuDisplay = function(ixChain){
    var targetNode, ref$;
    targetNode = this.data.getByIndexChain(ixChain);
    if (!targetNode) {
      return;
    }
    if (this.config.listViewOnly && isItem(targetNode)) {
      return;
    }
    if (!narrow_mode() || this.config.itemViewType === 'popup') {
      if (((ref$ = targetNode.categories) != null ? ref$.length : void 8) > 0) {
        return pub('menu-restore', [this.config.menu].concat(ixChain, [0]));
      }
      if (isItem(targetNode)) {
        this.data.resolveRecommendations(targetNode);
        if (this.config.itemViewType === 'popup') {
          this.view.showItemPopup(targetNode, ixChain, this.data);
          this.view.setSidebarState(initial(ixChain));
          this.view.setMenuState(initial(ixChain));
        } else {
          this.view.renderItem(targetNode, ixChain, this.data);
          this.view.showItemsPanel();
          this.view.setSidebarState(initial(ixChain));
          this.view.setMenuState(initial(ixChain));
        }
      } else {
        this.view.setSidebarState(ixChain);
        this.view.setMenuState(ixChain);
        this.view.hideItemsPanel();
      }
      if (narrow_mode()) {
        if (isItem(targetNode)) {
          this.view.moveSidebar(true);
          this.view.setSidebarState(initial(ixChain));
          this.view.setMenuState(initial(ixChain));
        } else if (isMenu(targetNode)) {
          this.view.moveSidebar(true);
          this.view.setSidebarState(ixChain);
          this.view.setMenuState(ixChain);
        }
      }
    } else {
      this.view.moveSidebar(isMenu(targetNode));
      this.view.setSidebarState(ixChain);
      this.view.setMenuState(ixChain);
    }
    return this.view.setCorrectSize();
  };
  ServdMenu.prototype.setInitialState = function(){
    if (!narrow_mode()) {
      return this.menuDisplay([0]);
    } else {
      this.view.moveSidebar(false);
      return this.view.pokeHeight();
    }
  };
  ServdMenu.prototype.provokeHeightReport = function(){
    return this.view.pokeHeight();
  };
  ServdMenu.prototype.onHeightChange = function(λ){
    return this.callbacks.height = λ;
  };
  ServdMenu.prototype.onDataReady = function(λ){
    return this.callbacks.ready = λ;
  };
  ServdMenu.prototype.onServdFetchComplete = function(λ){
    return this.callbacks.fetched = λ;
  };
  return ServdMenu;
}());
function partialize$(f, args, where){
  var context = this;
  return function(){
    var params = slice$.call(arguments), i,
        len = params.length, wlen = where.length,
        ta = args ? args.concat() : [], tw = where ? where.concat() : [];
    for(i = 0; i < len; ++i) { ta[tw[0]] = params[i]; tw.shift(); }
    return len < wlen && len ?
      partialize$.apply(context, [f, ta, tw]) : f.apply(context, ta);
  };
}
function bind$(obj, key, target){
  return function(){ return (target || obj)[key].apply(obj, arguments) };
}
//# sourceMappingURL=data:application/json;base64,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

